import { Component } from 'react';
import PT from 'prop-types';
import DeleteSittingControl from '../DeleteSittingControl';
import { Table } from 'edrolo/domains/teacherResultsTable';

export default class StudentNameCell extends Component {
  state = {
    showDeleteControl: false,
  };

  render() {
    const { student, sitting, deleteExamSitting, className } = this.props;
    const { showDeleteControl } = this.state;
    return (
      <Table.RowHeader
        onMouseEnter={() => this.setState({ showDeleteControl: true })}
        onMouseLeave={() => this.setState({ showDeleteControl: false })}
        className={className}
        isSticky
      >
        {sitting && sitting.submitted_ts ? (
          <DeleteSittingControl
            deleteExamSitting={deleteExamSitting}
            examId={sitting.exam}
            sittingId={sitting.id}
            showControl={showDeleteControl}
          />
        ) : null}
        {student.name}
      </Table.RowHeader>
    );
  }
}

StudentNameCell.propTypes = {
  student: PT.object,
  sitting: PT.object,
  deleteExamSitting: PT.func,
  className: PT.string,
};
